import { useHistory } from 'react-router-dom'

const useRowClick = (basePath: string) => {
    const history = useHistory()

    return (id: number, event: React.MouseEvent<HTMLElement>, page?: number) => {
        if (event?.ctrlKey || event?.metaKey) {
            window.open(`${basePath}/${id}`, '_blank')
        } else {
            history.push(`${basePath}/${id}`, page != null ? { page } : undefined)
        }
    }
}

export default useRowClick
